// Footer.jsx
import React, { useState } from "react";
import { View, Text, TextInput, StyleSheet, TouchableOpacity, Linking } from "react-native";
import Button from "../Compoents/Button/Button";
import "./Footer.css";
import { backgroundLight, headerPurple, primaryDark, secondaryDark } from "../Constants/Colors";
import { maxWidthContainer } from "../Constants/Sizes";
const Footer = () => {
  const [email, setEmail] = useState("");

  const handleSubscribe = () => {
    if (email) {
      console.log("Subscribing:", email);
      setEmail("");
    }
  };

  const openSocialMedia = (url) => {
    Linking.openURL(url).catch((err) => console.error("Failed to open URL:", err));
  };

  const socialLinks = [
    { name: "facebook", url: "https://facebook.com", icon: "f" },
    { name: "twitter", url: "https://twitter.com", icon: "t" },
    { name: "google", url: "https://google.com", icon: "g+" },
    { name: "pinterest", url: "https://pinterest.com", icon: "p" },
    { name: "linkedin", url: "https://linkedin.com", icon: "in" },
    { name: "instagram", url: "https://instagram.com", icon: "📷" },
  ];

  return (
    <View style={styles.footerWrapper}>
      {/* Wavy top using plain SVG + CSS */}

      <View style={{ backgroundColor: backgroundLight, height: 100 }}>
        <View
          style={{
            position: "absolute",
            top: 0,
            width: "100%",
            height: "100%",
            // overflow: "hidden",
            lineHeight: 0,
          }}
        >
          <View
            style={{
              position: "absolute",
              left: 0,
              top: 0,
              width: 0,
              height: 0,
              borderStyle: "solid",
              borderLeftWidth: 0,
              borderRightWidth: 800,
              borderBottomWidth: 100,
              borderLeftColor: "transparent",
              borderRightColor: "transparent",
              borderBottomColor: secondaryDark,
            }}
          />
          <View
            style={{
              position: "absolute",
              right: 0,
              top: 0,
              width: 0,
              height: 0,
              borderStyle: "solid",
              borderLeftWidth: 800,
              borderRightWidth: 0,
              borderBottomWidth: 100,
              borderLeftColor: "transparent",
              borderRightColor: "transparent",
              borderBottomColor: secondaryDark,
            }}
          />
          <View
            style={{
              position: "absolute",
              left: 0,
              top: 0,
              width: 0,
              height: 0,
              borderStyle: "solid",
              borderLeftWidth: 0,
              borderRightWidth: 400,
              borderBottomWidth: 100,
              borderLeftColor: "transparent",
              borderRightColor: "transparent",
              borderBottomColor: primaryDark,
            }}
          />
          <View
            style={{
              position: "absolute",
              right: 0,
              top: 0,
              width: 0,
              height: 0,
              borderStyle: "solid",
              borderLeftWidth: 400,
              borderRightWidth: 0,
              borderBottomWidth: 100,
              borderLeftColor: "transparent",
              borderRightColor: "transparent",
              borderBottomColor: primaryDark,
            }}
          />
        </View>
      </View>

      <View style={styles.footerContainer}>
        <View style={styles.contentRow}>
          {/* Locations */}
          <View style={styles.section}>
            <Text style={styles.sectionTitle}>Contact Us</Text>
            <Text style={styles.emailText}>info@instantdigits.com / +1(416) 877 2145</Text>
            <Text style={styles.locationText}>
              241 Snidercroft Rd, Concord, ON L4K 2J8,{"\n"}Canada.
            </Text>
            <Text style={[styles.locationText, styles.locationSpacing]}>
              Ariviyal Nagar, Northern Province, Sri{"\n"}Lanka.
            </Text>
          </View>

          {/* Follow us */}
          <View style={styles.section}>
            <Text style={styles.sectionTitle}>Follow Us</Text>
            <View style={styles.socialContainer}>
              {socialLinks.map((social, index) => (
                <TouchableOpacity
                  key={index}
                  style={styles.socialButton}
                  onPress={() => openSocialMedia(social.url)}
                >
                  <Text style={styles.socialIcon}>{social.icon}</Text>
                </TouchableOpacity>
              ))}
            </View>
          </View>

          {/* Subscription */}
          <View style={styles.section}>
            <Text style={styles.sectionTitle}>Subscription</Text>
            <Text style={styles.subscribeText}>Subscribe to our Instant Digits</Text>
            <TextInput
              style={styles.emailInput}
              placeholder="Email"
              placeholderTextColor="#999"
              value={email}
              onChangeText={setEmail}
              keyboardType="email-address"
            />
            <Button title="SUBSCRIBE" onPress={handleSubscribe} variant="reddish" size="large" />
          </View>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  footerWrapper: {
    position: "relative",
    backgroundColor: primaryDark, // main purple
    overflow: "hidden",
    width: "100%",
  },
  footerContainer: {
    paddingTop: 100, // so content starts under wave
    paddingBottom: 130,
    paddingHorizontal: 20,
    // maxWidth: maxWidthContainer,
    alignSelf: "center",
  },
  contentRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    // maxWidth: 1200,
    maxWidth: maxWidthContainer,
    alignSelf: "center",
    width: "100%",
    gap: 40,
  },
  section: {
    flex: 1,
    minWidth: 280,
  },
  sectionTitle: {
    fontSize: 24,
    fontWeight: "700",
    color: "#FFFFFF",
    marginBottom: 20,
  },
  locationText: {
    fontSize: 16,
    color: "#FFFFFF",
    lineHeight: 24,
    opacity: 0.9,
  },
  locationSpacing: {
    marginTop: 15,
  },
  emailText: {
    fontSize: 16,
    color: "#FFFFFF",
    marginBottom: 20,
    opacity: 0.9,
  },
  socialContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 12,
  },
  socialButton: {
    width: 48,
    height: 48,
    backgroundColor: "#FF4081",
    borderRadius: 4,
    alignItems: "center",
    justifyContent: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.2,
    shadowRadius: 4,
    elevation: 3,
  },
  socialIcon: {
    fontSize: 20,
    fontWeight: "700",
    color: "#FFFFFF",
  },
  subscribeText: {
    fontSize: 16,
    color: "#FFFFFF",
    marginBottom: 20,
    opacity: 0.9,
  },
  emailInput: {
    backgroundColor: "#FFFFFF",
    borderRadius: 4,
    paddingVertical: 14,
    paddingHorizontal: 16,
    fontSize: 16,
    marginBottom: 12,
    color: "#333",
  },
});

export default Footer;
